import { Head } from '@inertiajs/react'
import type { ReactNode } from 'react'

import { ComingSoon } from '@/components/ComingSoon'
import { PageHeader } from '@/components/PageHeader'
import { DashboardLayout } from '@/layouts/DashboardLayout'

function PositionsIndex() {
  return (
    <>
      <Head title="Positions" />

      <div className="mx-auto max-w-6xl px-8 py-10">
        <PageHeader
          title="Positions"
          description="Your commitments, capital called, and distributions received across funds."
        />

        <ComingSoon
          title="To implement"
          description="Per-fund breakdown: commitment, called / unfunded, distributions by kind, and current NAV."
        />
      </div>
    </>
  )
}

export default Object.assign(PositionsIndex, {
  layout: (page: ReactNode) => <DashboardLayout>{page}</DashboardLayout>,
})
